import DefinitionList from './DefinitionList';

export default DefinitionList;